import React, { useState, useEffect } from 'react';
import { MdNotifications, MdClose, MdCheckCircle } from 'react-icons/md';

/**
 * Popup z prośbą o przyznanie uprawnień do powiadomień
 */
export default function NotificationPermissionPrompt({ onClose, onGrant }) {
    const [isVisible, setIsVisible] = useState(true);

    useEffect(() => {
        // Sprawdź czy użytkownik już wcześniej odrzucił powiadomienia
        const permission = Notification.permission;
        if (permission === 'denied') {
            // Jeśli odrzucono, nie pokazuj popupu (użytkownik musi odblokować ręcznie w ustawieniach przeglądarki)
            setIsVisible(false);
            if (onClose) onClose();
        }
    }, [onClose]);

    if (!isVisible) return null;

    const handleRequestPermission = async () => {
        try {
            // Na Android requestPermission musi być wywołane w kontekście user gesture
            // Upewniamy się, że jest wywoływane bezpośrednio z kliknięcia
            let permission;
            try {
                permission = await Notification.requestPermission();
            } catch (error) {
                console.error('[NotificationPermissionPrompt] Błąd podczas żądania uprawnień:', error);
                alert('Nie udało się poprosić o uprawnienia. Upewnij się, że przeglądarka obsługuje powiadomienia i spróbuj ponownie.');
                setIsVisible(false);
                if (onClose) onClose();
                return;
            }
            if (permission === 'granted') {
                if (onGrant) {
                    await onGrant();
                }
                setIsVisible(false);
                if (onClose) onClose();
            } else if (permission === 'denied') {
                // Użytkownik odrzucił - pokaż instrukcję
                alert('Powiadomienia zostały zablokowane. Aby je włączyć:\n\n' +
                    '1. Kliknij ikonę kłódki w pasku adresu przeglądarki\n' +
                    '2. Znajdź opcję "Powiadomienia"\n' +
                    '3. Zmień na "Zezwól"\n' +
                    '4. Odśwież stronę');
                setIsVisible(false);
                if (onClose) onClose();
            } else {
                // Użytkownik zamknął prompt bez decyzji
                setIsVisible(false);
                if (onClose) onClose();
            }
        } catch (error) {
            console.error('[NotificationPermissionPrompt] Błąd żądania uprawnień:', error);
            setIsVisible(false);
            if (onClose) onClose();
        }
    };

    const handleDismiss = () => {
        setIsVisible(false);
        if (onClose) onClose();
    };

    return (
        <div className="fixed inset-0 z-[10000] flex items-center justify-center
                      bg-black bg-opacity-50 dark:bg-opacity-70">
            <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl
                          max-w-md w-full mx-4 p-6">
                <div className="flex items-start justify-between mb-4">
                    <div className="flex items-center gap-3">
                        <MdNotifications className="text-blue-500" size={32} />
                        <h2 className="text-xl font-semibold text-gray-900 dark:text-gray-100">
                            Włącz powiadomienia
                        </h2>
                    </div>
                    <button
                        onClick={handleDismiss}
                        className="p-1 hover:bg-gray-100 dark:hover:bg-gray-700 rounded"
                    >
                        <MdClose size={24} />
                    </button>
                </div>

                <p className="text-gray-700 dark:text-gray-300 mb-6">
                    Włącz powiadomienia, aby otrzymywać informacje o:
                </p>

                <ul className="space-y-2 mb-6 text-gray-600 dark:text-gray-400">
                    <li className="flex items-center gap-2">
                        <MdCheckCircle className="text-green-500" size={20} />
                        <span>Dodaniu Cię do wydarzenia</span>
                    </li>
                    <li className="flex items-center gap-2">
                        <MdCheckCircle className="text-green-500" size={20} />
                        <span>Usunięciu Cię z wydarzenia</span>
                    </li>
                    <li className="flex items-center gap-2">
                        <MdCheckCircle className="text-green-500" size={20} />
                        <span>Propozycjach udziału w wydarzeniach</span>
                    </li>
                </ul>

                <div className="flex gap-3">
                    <button
                        onClick={handleDismiss}
                        className="flex-1 px-4 py-2 text-gray-700 dark:text-gray-300 rounded
                                 hover:bg-gray-100 dark:hover:bg-gray-700
                                 border border-gray-300 dark:border-gray-600"
                    >
                        Nie teraz
                    </button>
                    <button
                        onClick={handleRequestPermission}
                        className="flex-1 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600
                                 dark:bg-blue-600 dark:hover:bg-blue-700
                                 font-medium"
                    >
                        Włącz powiadomienia
                    </button>
                </div>
            </div>
        </div>
    );
}


